import React from 'react';
import FundingDealStageBadge from './FundingDealStageBadge';

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const FundingDealTaskList = ({ deals, onSelect }) => {
  const tasks = (deals || [])
    .filter((deal) => deal.nextTask)
    .sort((a, b) => {
      const aTime = a.nextTaskDueAt ? new Date(a.nextTaskDueAt).getTime() : Infinity;
      const bTime = b.nextTaskDueAt ? new Date(b.nextTaskDueAt).getTime() : Infinity;
      return aTime - bTime;
    });

  if (!tasks.length) {
    return <p className="text-sm text-[var(--fg-muted)]">No upcoming pipeline tasks.</p>;
  }

  return (
    <div className="space-y-3">
      {tasks.map((deal) => (
        <button
          key={deal.id}
          type="button"
          onClick={() => onSelect?.(deal)}
          className="flex w-full items-center justify-between rounded-xl border border-[var(--fg-line)] bg-white px-4 py-3 text-left dark:bg-slate-950/20"
        >
          <div>
            <div className="font-medium text-[var(--fg-text)]">{deal.nextTask}</div>
            <div className="text-xs text-[var(--fg-muted)]">
              {deal.clientName} · {deal.lenderName}
            </div>
          </div>
          <div className="text-right">
            <FundingDealStageBadge stage={deal.stage} />
            <div className="mt-1 text-xs text-[var(--fg-muted)]">{formatDate(deal.nextTaskDueAt)}</div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default FundingDealTaskList;
